export namespace Regex {
  export const twoCharSequence = new RegExp(`.{1,2}`, 'g');
}
